import { useEffect, useState } from "react";
import logger from "../../utils/logger";



export const UseVisibleLoadingModal = (params) => {


    const [enableModal, setEnableModal] = useState(false)

    useEffect(() => {

        const handleSpanVer = () => {
            const mobileSize = window.innerWidth
            logger.info('tamaño actual: ', mobileSize)
            if (mobileSize <= 768) {
                setEnableModal(true)
            } else {
                setEnableModal(false)
            }
        }

        handleSpanVer()


        window.addEventListener('resize', handleSpanVer)

        // logger.info('enableAcction cambio a: ', enableModal)

    }, [enableModal])


    return { enableModal }
}